import { Injectable } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { HttpParams} from '@angular/common/http';

import { AuthHttpService } from './auth-http.service';

import { Globals } from '../globals';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CreateDialogComponent } from '../shared/dialogs/create-dialog/create-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { AdminSensorErrorsDialogComponent } from '../routes/admin/pages/admin-sensors/admin-sensor-errors-dialog/admin-sensor-errors-dialog.component';
import { RedirectDialogComponent } from '../shared/dialogs/redirect-dialog/redirect-dialog.component';
import {Router} from '@angular/router';
import {filter} from "rxjs/operators";
import {SensorService} from "./sensor.service";

@Injectable({
    providedIn: 'root'
})
export class SensorsService {

    private _sensorsData = [];
    public _dataSubject = new Subject<any>();
    public isDataAvailable = false;

    // отвечает за очистку селекта датчиков, чтобы отменять автоматическое заполнение селекта при  загрузке страниц консолидированных отчетов
    private clear_select = false;

    public error_data_lang: string;
    public res_dict_status: any[];
    public copy_sensor_data: any = [];
    public warningLevel: any;
    public critical: any;
    public sensor_with_errors: any;
    public _sensors: any;
    public sensorsWithWarnings: any[];
    public matDialog: any;
    public checkedLength: any;
    showErrorsPopUp = false;
    firstWar: any;
    for_sensors: string;
    selectedSensorsProjects: any;
    projectList: any = [];
    user_email: any;
    user_name: any;
    cancel_report: boolean ;
    private callGkMethod = new Subject<any>();
    cgkObservable = this.callGkMethod.asObservable();
    resetReport: boolean;
    selectedSensors: any = [];
    hasWarnings: any = '';
    warningsArr = [];
    warningsList = [];
    errors: any;
    sensorsChecked = false;
    applied: boolean;
    sensorSelected: number;

    constructor(
        private http: AuthHttpService,
        public dialog: MatDialog,
        public Globals: Globals,
        public translate: TranslateService,
        private router: Router,
        public sensorService: SensorService,
        ) {
        this.Globals.langJS.subscribe(this.onLangChanged.bind(this));
        this.onLangChanged();
    }
    onLangChanged() {
        forkJoin([
            this.translate.get('error_data'),
            this.translate.get('sensor_with_errors'),
            this.translate.get('sensors'),
            this.translate.get('for_sensors'),
        ]).subscribe((res) => {
            this.error_data_lang = res[0];
            this.sensor_with_errors = res[1];
            this._sensors = res[2];
            this.for_sensors = res[3];
            this.translateSensorErrors(this.copy_sensor_data, this.Globals.lang);
        });
    }
    public getClearSelect() {
        return this.clear_select;
    }
    public setClearSelect() {
        this.clear_select = true;
    }
    private setData(sensors_data: any) {
        this._sensorsData = sensors_data;
        this._dataSubject.next(sensors_data);
    }

    public sensors(params: any = {}): Subject<any> {

        if (!this._sensorsData.length) {
            this.fetchSensors(params);
        }
        // console.log('this._dataSubject;',this._dataSubject);
        return this._dataSubject;
    }

    // функция для перевода, принимает строку, преобразовывает в массив, каждый элемент массива переводит и возвращает обратно строку

    public translateStatus = (status_list: string) => {
        const status_arr = status_list.split(', ');

        // console.log('string to status_arr', status_arr);

        // переводим
        const translated_arr = [];
        let translated_status: string;

        status_arr.forEach(word => {
            // меняем на перевод в зависимости от выбранного языка
            const current_lang = this.Globals.lang;
            const found_word = this.res_dict_status.find((word_obj: { code: string; }) => word_obj.code == word);
            if (Boolean(found_word)) {
              const found_name_arr = JSON.parse(found_word.name);
              translated_arr.push(found_name_arr[current_lang]);
            } else {
              const found_name_arr = {'en': 'No status. Check reading', 'es': 'Sin Estado. lectura de cheques', 'ru': 'Нет статуса. Проверьте считывание'};
              translated_arr.push(found_name_arr[current_lang]);
            }
            // console.log('found_name_arr', found_name_arr[current_lang]);
        });
        translated_status = translated_arr.toString();
        // добавляем пробел после запятой
        translated_status = translated_status.split(',').join(', ');
        return translated_status;
    }

    public async fetchSensors(params: any = {}) {
        let sensors_params: HttpParams = new HttpParams();
        Object.entries(params).forEach(entry => {
            const [key, value] = entry;
            if (Boolean(key) && Boolean(value)) {
                sensors_params = sensors_params.set(key, value.toString());
            }
        });

        try {
            // получаем датчики, статусы и полосы и объеиняем их в один массив
            const res = await this.http.get('/api/admin-sensors/data', { params: sensors_params }).toPromise();
            const ids: string[] = [];
            // let statusParams: HttpParams = new HttpParams();
            const statusParams = { 'sensor_id_list': '' };
            let new_res = [];
            if (!res.body.length) {
                new_res = Object.values(res.body);
            } else {
                new_res = res.body;
            }

            new_res.forEach((sensor: { sensor_id: string; }) => {
                ids.push(sensor.sensor_id);
            });

            if (Boolean(this.Globals.user) && (this.Globals.user.role.name === 'Superadmin' || this.Globals.user.role.name === 'Admin')) {
                //
            } else {
                new_res.forEach(sensor => {
                    sensor.ip = '';
                });
            }

            statusParams.sensor_id_list = JSON.stringify(ids);

            const fetchData$ = forkJoin({
                DictStatusData: this.http.get('/api/dict/det_sensor_status_dict'),
                statusData: this.http.post('/api/sensor/status_v', statusParams),
                lanesData: this.http.post('/api/sensor/v_sensor_lanes', statusParams),
                sensorWarnings: this.http.post('/api/admin-sensors/warnings', statusParams),
                sensorHardWare: this.http.post('/api/admin-sensors/hard-ware', statusParams)
            });

            const statusRes = await fetchData$.toPromise();

            const res_status = statusRes.statusData.body;
            const res_lanes = statusRes.lanesData.body;
            const res_warnings = statusRes.sensorWarnings.body;
            const res_hardware = statusRes.sensorHardWare.body;

            // добавили получение из словаря перевода детальных статусов
            this.res_dict_status = statusRes.DictStatusData.body;
            // console.log('res_dict_status', res_dict_status);

            // меняем формат даты под сафари
            let sensors_data = new_res.map((sensor) => {
                if (sensor.update_ts != null) {
                    sensor.update_ts = sensor.update_ts.replace(' ', 'T');
                }
                return sensor;
            });

            sensors_data.forEach(s => {
                // цепляем полосы к датчикам проекта
                s.lanes = [];
                res_lanes.forEach((lane: { sensor_id: any; }) => {
                    if (s.sensor_id == lane.sensor_id) {
                        s.lanes.push(lane);
                    }
                });

                s.serial_number = [];
                res_hardware.map(data => {
                    if (s.sensor_id == data.sensor_id) {
                        s.serial_number.push(data.serial_number);
                    }
                });

                /**
                 * We attach the warnings to the project sensors
                */
                s.warnings = [];
                const sensorWarningsArr = Object.keys(res_warnings).map((key) => res_warnings[key]);
                sensorWarningsArr.map(war => {
                    if (war[0].sensor_id == s.sensor_id) {
                        s.warnings = war;
                    }
                });


                // далее проверяем таблицу статусов и в случае соответствия выставляем текущий статус
                s.status_v = 0;
                s.status_v_list = '';
                s.status_v_list_codes = '';

                if (res_status.length > 0) {
                    res_status.forEach((sv: { sensor_id: any; current_status_code: any; current_status_list: any; }) => {
                        if (sv.sensor_id == s.sensor_id) {
                            s.status_v = sv.current_status_code;

                            // добавляем список в виде кодов, чтобы в дальнейшем использовать их прпи переключении языка
                            s.status_v_list_codes = sv.current_status_list;

                            // здесь пробуем преобразовать список статусов в нужный нам перевод
                            s.status_v_list = this.translateStatus(sv.current_status_list);
                            // console.log('s.status_v_list_translated', s.status_v_list_translated);
                        }
                    });
                }
                if (s.del_from_project) {
                    s['status_v'] = 3;
                }
            });

            /* СОРТИРОВКА по статусу и по имени внутри статуса */
            const sorted_arr = this.sortSensorsNameStatus(JSON.stringify(sensors_data));
            sensors_data = JSON.parse(JSON.stringify(sorted_arr));
            this.copy_sensor_data = sensors_data;
            this.translateSensorErrors(sensors_data, this.Globals.lang);
            this.setData(sensors_data);

        } catch (err) {
            if (err.status !== 401 && err.status !== 403 && err.status !== 423 && this.Globals.error) {
                this.Globals.error = false;
                const dialog = this.dialog.open(CreateDialogComponent, <MatDialogConfig>{
                    data: {
                        act: 'error',
                        text: this.error_data_lang,
                        icon_class: 'dialog-icon-warning'
                    }
                });
                this.isDataAvailable = true;
            }
        }
    }

    public getSensorsGlobalData() {
        return this._sensorsData;
    }
    public clearSensorsGlobalData() {
        this.setData([]);
    }

    /**
     * функция для сортировки датчиков проекта по статусу и по имени внутри статуса
     * @param sensors_array - входящий список датчиков
    **/
    private sortSensorsNameStatus(sensors_array: string) {
        // требуется отсортировать по статусу и по имени внутри статусов
        // для этого создадим массивы по статусам, отсортируем в них по имени, а затем объединим

        const status_green_arr = [];
        const status_red_arr = [];
        const status_yellow_arr = [];
        const status_grey_arr = [];
        const status_blue_arr = [];

        JSON.parse(sensors_array).forEach(sensor => {
            switch (sensor.status_v) {
                case 0:
                    status_red_arr.push(sensor);
                    break;
                case 1:
                    status_green_arr.push(sensor);
                    break;
                case 2:
                    status_yellow_arr.push(sensor);
                    break;
                case 3:
                    status_grey_arr.push(sensor);
                    break;
                case 4:
                    status_blue_arr.push(sensor);
                  break;
            }
        });

        // сортируем массивы по имени если в массивах больше 1 элемента
        if (status_red_arr.length > 1 ) {
            status_red_arr.sort((a, b) => a.name.localeCompare(b.name));
        }
        if (status_green_arr.length > 1 ) {
            status_green_arr.sort((a, b) => a.name.localeCompare(b.name));
        }
        if (status_yellow_arr.length > 1 ) {
            status_yellow_arr.sort((a, b) => a.name.localeCompare(b.name));
        }
        if (status_grey_arr.length > 1 ) {
            status_grey_arr.sort((a, b) => a.name.localeCompare(b.name));
        }
        if (status_blue_arr.length > 1 ) {
          status_blue_arr.sort((a, b) => a.name.localeCompare(b.name));
        }

        // объединяем в один и меняем предыдущий массив датчиков
        let sorted_arr = [];
        sorted_arr = [...status_green_arr, ...status_yellow_arr, ...status_red_arr, ...status_blue_arr, ...status_grey_arr];
        sensors_array = JSON.parse(JSON.stringify(sorted_arr));
        return sensors_array;
    }

   /**
    * Translate sensor errors and add neц item to translate array with translations
    * @param sensors
    * @param lang en | es | ru
    */
   public translateSensorErrors(sensors: any, lang: string) {
       sensors.forEach(sensor => {
       sensor.warnings_number = sensor.warnings.length;
           sensor.warnings.map(w => {
               w.tr_code_name  = JSON.parse(w.code_name)[lang];
               w.tr_level_name = JSON.parse(w.level_name)[lang];
               w.tr_type_name  = JSON.parse(w.type_name)[lang];
           });
       });
   }

    /**
     * Sort sensor warnings level 2 first than 1 , 0.
     * @param warnings
     */
    sortWarnings(warnings: any) {
        const war = [ ...warnings ];
        war.sort((a, b) => {
            return a.level - b.level;
        });
         return war;
    }

    /**
     * Set icon for suitable error.
     * @param sensor
     */
    setErrorsImage(sensor: any) {
        if (sensor && sensor.warnings?.length) {
            const warnings = this.sortWarnings(sensor.warnings);
            const last = warnings.length - 1;
            this.warningLevel = warnings[last].level;
            this.firstWar = warnings[last].tr_code_name;
            switch (this.warningLevel) {
                case 2:
                   return '../assets/icons-map/warning-critical.svg';
                case 1:
                    return '../assets/icons-map/warning.svg';
                case 0:
                   return '../assets/icons-map/warning-info.svg';
            }
        } else {
            return '../assets/icons-map/noErrorIcon.svg';
        }
    }

    /**
     * Chek sensor has error.
     * @param sensors
     */
    checkErrors(sensors: any) {
        this.warningsArr = [];
        if (sensors) {
        this.sensorsWithWarnings = [ ...sensors ];
        if (this.selectedSensors.length) {
            this.sensorsWithWarnings = this.sensorsWithWarnings.filter(sensor => {
                return this.selectedSensors.includes(sensor.sensor_id) && Number(sensor.status_v) !== 3;
            });
        } else {
            this.sensorsWithWarnings = this.sensorsWithWarnings.filter(sensor => {
                 return Number(sensor.status_v) !== 3;
            });
        }
         this.sensorsWithWarnings.map(sensor => {
             if (sensor.status_v != undefined && sensor.status_v != 3 && sensor.warnings.length) {
                 this.warningsArr.push(sensor.warnings);
                     sensor.warnings.map( w => {
                         if (w.level >= 2 ) {
                             this.critical = [ ...sensors ];
                         }
                    });
                }

             });
        }
        this.errors = false;
        return this.warningsArr.length;
    }

    /**
     * Open mat dialog if sensor has warnings.
     */
    openSensorWarningsMatDialog() {
        this.sensorsChecked = true;
        this.warningsList = [];
        let text = '';
        const sensorsNames: any = [];
        this.selectedSensorsProjects = [];
        this.sensorsWithWarnings = this.sensorsWithWarnings.filter(sensor => {
          if (this.selectedSensors.length) {
            return this.selectedSensors.includes(sensor.sensor_id) && Number(sensor.status_v) !== 3;
          } else {
            return  Number(sensor.status_v) !== 3;
          }
        });
        this.sensorsWithWarnings.map( war => {
            this.hasWarnings = '';
            if (war.warnings && war.warnings.length) {
                sensorsNames.push(`«${war.name}»`);
                const warnings = this.sortWarnings(war.warnings);
                const last = warnings.length - 1;
                this.warningLevel = warnings[last].level;
                warnings.map( w => {
                    this.warningsList.push(w.tr_code_name);
                });
                this.firstWar = warnings[last].tr_code_name;
                this.hasWarnings = warnings[last].tr_code_name;
            }
         });
         this.warningsList = [...new Set(this.warningsList)];
        text = this.for_sensors + ' <span class=\'sen-errors\'>' + sensorsNames.join(',  ') + '</span> ' + this.sensor_with_errors + ' <br>'
          + '<span class=\'warning-' + this.warningLevel + '\'>' + this.warningsList.join('<br>') + '</span>';
        this.selectedSensorsProjects = this.getProjectsListForGivenSensors(this.sensorsWithWarnings);
        if (this.warningsArr.length) {
            // this.sensorsChecked = true;
            this.matDialog = this.dialog.open(RedirectDialogComponent, <MatDialogConfig>{
                data: {
                    warningDialog: text,
                    routerLinkText: this._sensors,
                    routerlink: '/admin/admin-sensors',
                    sensors_projects: this.selectedSensorsProjects,
                    resetButt: true,
                    marRight: 'mr-0',
                    icon_class: 'dialog-icon-warning',
                    ng_class: 'router-but-class',
                    custom_dialog_box: 'custom_dialog_box',
                    dialog_button_box: 'dialog_button_box'
                }
            });
        }
         return true;
    }

    /**
     * For the filter-output a list of projects for existing sensors
     * @param sensorsWithWarnings
     */
    getProjectsListForGivenSensors(sensorsWithWarnings: any) {
        const projects: any = [];
        this.projectList = [];

        sensorsWithWarnings.forEach(sensor => {
            if (sensor.projects && sensor.projects.length) {
                sensor.projects.map(project => {
                    projects.push( {name: project.name, projects_id: project.projects_id});
                });
            }
        });

        // Delete duplicates
        this.projectList = [...new Map(projects.map(item => [item['name'], item])).values()];
        return this.projectList;
    }

    /**
     * Show sensor error in Dialog.
     * @param sensor
     * @param filtersList
     * @param lang
     */
    showErrors(sensor: any, lang: any, filtersList?: any, ) {
        const sensorList = filtersList || [sensor];
        this.translateSensorErrors(sensorList, lang );
        this.showErrorsPopUp = true;
        const dialogRef = this.dialog.open(AdminSensorErrorsDialogComponent, <MatDialogConfig>{
            data: {
                sensorName: sensor.name,
                warnings: this.sortWarnings(sensor.warnings)
            }
        });
        dialogRef.afterClosed().subscribe( result => {
            document.body.style.overflow = 'auto';
        });
    }

    hideFoundIfSingleItemSelected(sensor_select: any) {
        const selected = typeof sensor_select === 'string' ? [sensor_select] : sensor_select;
        return  selected ? selected.length != 1 : true;
    }

    /**
     * Send У-ьфшд шf report generation has started
     */
    gkReportGenerationEmail() {
          this.cancel_report = false;
          this.callGkMethod.next();
          const data = { 'email': this.user_email, 'name' : this.user_name };
          try {
              this.http.post('/api/sensors/statistics/send/email_gk', data).subscribe((res) => {});
          } catch (e) {
              console.log(e);
          }
      }

    /**
    * Send an email if Gk-report saved successfully
    */
    gkReportSavedEmail(file_name) {
        const url = window.location.origin + '/report/consolidated-statistics-gk';
        const data = { 'email': this.user_email, 'name' : this.user_name, 'file_name' : file_name, 'url': url };
        try {
            this.http.post('/api/sensors/statistics/file/uploaded_gk', data).subscribe((res) => {});
        } catch (e) {
            console.log(e);
        }
    }
}
